import {Component, Input, OnInit} from '@angular/core';
import {SignStepperStep} from '@shared/components/core-sign/models/sign-stepper-step';

@Component({
	selector: 'amd-sign-stepper',
	templateUrl: './sign-stepper.component.html',
	styleUrls: ['./sign-stepper.component.scss']
})
export class SignStepperComponent implements OnInit {

	@Input() enableDigitalSign: boolean;
	@Input() steps: SignStepperStep[];
	@Input() currentStep: SignStepperStep;

	constructor() {
	}

	ngOnInit(): void {
	}

}
